var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"dl export-button",attrs:{"outlined":"","small":"","elevation":"0","disabled":_vm.checkDisabled},on:{"click":function($event){return _vm.$emit('click')}}},[_c('v-icon',{staticClass:"export-icon",attrs:{"size":"14"}},[_vm._v("mdi-tray-arrow-down")]),_vm._v(" "+_vm._s(_vm.text ? _vm.text : "내려받기")+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }